/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b2e8d56"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "充值提示说明", -1));
const _hoisted_2 = {
  class: "dialog-footer"
};
import { apiUsdkGetProductId, apiUsdkPayDesc, apiUsdkPayDescEdit } from '@/api/usdk';
import UEditor from '@ultra/share/components/UEditor/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'payDesc',
  props: {
    gid: {
      type: [Number, String],
      required: true,
      default: 0
    },
    channel: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const productId = ref('');
    const serverId = ref('');
    const getProductId = cid => {
      apiUsdkGetProductId({
        gid: props.gid,
        cid: cid || props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          productId.value = res.data.productId;
          serverId.value = res.data.serverId;
        }
      });
    };
    const payDesc = ref('');
    const handleGetPayDesc = async cid => {
      const res = await apiUsdkPayDesc({
        gid: props.gid,
        cid: cid || props.channel.cid
      });
      if (res.code === 0) {
        payDesc.value = res.data.desc;
        dialogVisible.value = true;
      }
    };
    const handleSavePayDesc = async () => {
      confirmLoading.value = true;
      const res = await apiUsdkPayDescEdit({
        productId: productId.value,
        payDesc: payDesc.value
      });
      if (res.code === 0) {
        handleClose();
      }
      confirmLoading.value = false;
    };
    const show = channel => {
      getProductId(channel.cid);
      handleGetPayDesc(channel.cid);
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_dialog = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: `${__props.channel.name}渠道 充值提示说明`,
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "700px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(confirmLoading),
          onClick: handleSavePayDesc
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_hoisted_1, _createVNode(UEditor, {
          modelValue: _unref(payDesc),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(payDesc) ? payDesc.value = $event : null)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["title", "modelValue"])]);
    };
  }
});